import { useEffect } from "react";
import pageMetadata from "@/lib/pageMetadata.json";
import {applySeo,seoModel,routeSeo,SEO_EVENT} from "@/lib/seo";
import { useLocation } from "react-router-dom";
import { useLang } from "@/i18n/LanguageContext";
const titles={
  "/support/contribute":["Sostieni PlantAdopting", "Support PlantAdopting"],
  "/login":["Accedi", "Log in"],
  "/register":["Crea un account", "Create an account"],
  "/list-your-farm":["Registra un soggetto", "Register a subject"],
  "/dashboard":["La mia dashboard", "My dashboard"],
  "/payments/result":["Esito del pagamento", "Payment result"],
  "/payments/history":["I tuoi pagamenti", "Your payments"],
};
export default function PageMeta(){
 const {pathname}=useLocation();const {lang}=useLang();
 useEffect(()=>{
  const dynamic=/^\/(farm|azienda|allevamento|vivaio|professionista|comune|ente|parco|area-protetta|giardino|orto-botanico|oasi|centro-ambientale|associazione|fondazione|soggetto)\//.test(pathname)?["Scheda soggetto","Subject profile"]:pathname.startsWith("/crops/")?["Scheda coltura","Crop profile"]:(pathname.startsWith("/projects/") || pathname.startsWith("/progetto/"))?["Scheda progetto","Project details"]:pathname.startsWith("/opportunities/")?["Esperienza e opportunità","Experience and opportunity"]:pathname.startsWith("/dashboard/farms/")?(pathname.endsWith("/billing")?["Piano e incassi","Plan and payments"]:["Modifica soggetto","Edit subject"]):pathname.startsWith("/payments/opportunities/")?["Formula e condizioni","Arrangement and terms"]:["Pagina non trovata","Page not found"];

  const dynamicRoute = /^\/(farm|crops|projects|opportunities)\/[^/]+/.test(pathname);
  const update = () => {
    const metadata = routeSeo(pathname,lang);
    const publicMetadata = pageMetadata.pages[pathname]?.[lang];
    applySeo(seoModel(pathname,lang,metadata || {
      title:publicMetadata?.title || (titles[pathname]||dynamic)[lang==="it"?0:1],
      description:publicMetadata?.description,
      noindex: dynamicRoute || (!publicMetadata && !titles[pathname])
    }));
    document.documentElement.lang=lang==="it"?"it":"en";
  };
  update(); window.addEventListener(SEO_EVENT, update);
  return () => window.removeEventListener(SEO_EVENT, update);
 },[pathname,lang]);return null;
}
